import Article from './documents/Article.vue';
import EduService from './documents/EduService.vue';
import Faq from './documents/Faq.vue';
import Job from './documents/Job.vue';
import Page from './documents/Page.vue';
import Person from './documents/Person.vue';
import Magazine from './documents/Magazine.vue';
export const MIN_INPUT_LENGTH = 2;
export const indexesCardComponents = {
    people: Person,
    edu_services: EduService,
    news: Article,
    jobs: Job,
    magazine: Magazine,
    rnd: Article,
    faq: Faq,
    pages: Page,
};
export function getStandAloneSearchArgsDefaults(indexUid) {
    const stdArgs = primeIndexDefs[indexUid] || txIndexDefs[indexUid];
    if (stdArgs) {
        const args = structuredClone(stdArgs);
        args.limit = 12;
        return args;
    }
    return {};
}
export function getTXIndexUid(indexUid) {
    const indexUidTX = `${indexUid}_tx`;
    return txIndexDefs[indexUidTX] ? indexUidTX : indexUid;
}
export function getPrimeIndexUid(indexUid) {
    return indexUid.replace(/_tx$/, '');
}
function mixinDefaults(def = {}) {
    return structuredClone(Object.assign(Object.assign({}, def), { attributesToHighlight: ['title'].concat(def.attributesToHighlight || []), highlightPreTag: '<mark>', highlightPostTag: '</mark>', 
        // TODO wait until the "first" matching strategy is available
        //  @link https://roadmap.meilisearch.com/c/62-policy-for-matching-words
        //matchingStrategy: 'last',
        matchingStrategy: 'all' }));
}
export function getMultiSearchArgsDefaults(titleExclusive) {
    if (titleExclusive) {
        return structuredClone(Object.assign(Object.assign({}, txIndexDefs), { people: primeIndexDefs.people }));
    }
    else {
        return structuredClone(primeIndexDefs);
    }
}
const primeIndexDefs = {
    edu_services: mixinDefaults({
        limit: 4,
        filter: [
            `event.ends_at_time IS EMPTY OR event.ends_at_time >= ${Math.round(new Date().getTime() / 1000)}`,
        ],
    }),
    news: mixinDefaults({
        attributesToHighlight: ['excerpt'],
    }),
    jobs: mixinDefaults({
        limit: 4,
        filter: [
            `deadline >= ${Math.round(new Date().getTime() / 1000)}`,
        ],
    }),
    magazine: mixinDefaults({
        limit: 4,
    }),
    rnd: mixinDefaults({
        attributesToHighlight: ['excerpt'],
    }),
    faq: mixinDefaults({
        attributesToHighlight: ['answer'],
    }),
    pages: mixinDefaults({
        attributesToHighlight: ['excerpt'],
    }),
    people: mixinDefaults(),
};
const txIndexDefs = {
    edu_services_tx: mixinDefaults({
        limit: 4,
        filter: [
            `event.ends_at_time IS EMPTY OR event.ends_at_time >= ${Math.round(new Date().getTime() / 1000)}`,
        ],
    }),
    news_tx: mixinDefaults(),
    jobs_tx: mixinDefaults({
        limit: 4,
        filter: [
            `deadline >= ${Math.round(new Date().getTime() / 1000)}`,
        ],
    }),
    magazine_tx: mixinDefaults({
        limit: 4,
    }),
    rnd_tx: mixinDefaults(),
    faq_tx: mixinDefaults(),
    pages_tx: mixinDefaults(),
};
